module.exports = __webpack_public_path__ + "img/i14.7ba45e8a.svg";